exports = module.exports = require("../../../../../../../tyler-components-web-cli/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ":host{display:block}", ""]);
